module.exports = __webpack_public_path__ + "static/img/mp3_lg.7fdb282.png";